import { render } from "./invoice-form.vue?vue&type=template&id=087630b5&scoped=true"
import script from "./invoice-form.vue?vue&type=script&lang=js"
export * from "./invoice-form.vue?vue&type=script&lang=js"

import "./invoice-form.vue?vue&type=style&index=0&id=087630b5&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087630b5"]])

export default __exports__